<template>
	<div v-on="$listeners" class="surf-inline-three-image-text-wrapper">
		<div class="surf-inline-three-image-text surf-hover-trigger">
			<div class="image">
				<el-image :src="formattedItem.image" fit="cover" class="image-content surf-transition-image-scale">
					<template #placeholder>
						<div class="image-placeholder"></div>
					</template>
					<template #error>
						<div class="image-error">
							<i class="el-icon-picture-outline error-icon"></i>
						</div>
					</template>
				</el-image>
			</div>
			<div class="image-shadow">
				<el-image :src="formattedItem.image" fit="cover" class="image-content-shadow">
					<template #placeholder>
						<div class="image-placeholder"></div>
					</template>
					<template #error>
						<div class="image-placeholder"></div>
					</template>
				</el-image>
			</div>

			<div class="content">
				<div class="value text-overflow2">{{ formattedItem.value }}</div>
				<div class="value-section">
					<div class="date">{{ normalizeYMDFormat(formattedItem.date) }}</div>
					<div class="sub-value">{{ formattedItem.value2 }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { normalizeYMDFormat } from '@/utils/format';

const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	formatter: {
		type: Function,
		default: null
	}
});

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		return { ...props.item, ...formattedData };
	}
	return props.item;
});
</script>

<style lang="less" scoped>
@import '@/style/global.less';

@image-text-box-border-radius: 8px;
@image-ratio: 56.16%;
@light-color: #fff;
@light-color-rgb: 255, 255, 255;
@dark-color-rgb: 29, 31, 32;
@border-color: rgba(0, 0, 0, 0.05);

.surf-inline-three-image-text-wrapper {
	position: relative;

	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		z-index: 3;
		width: 200%;
		height: 200%;
		border: 2px solid @border-color;
		border-radius: @image-text-box-border-radius * 2;
		transform: scale(0.5);
		transform-origin: 0 0;
		pointer-events: none;
	}
}

.surf-inline-three-image-text {
	position: relative;
	padding-bottom: 62px;
	border-radius: @image-text-box-border-radius;
	cursor: pointer;
	overflow: hidden;

	.image-shadow {
		position: absolute;
		bottom: 0;
		padding-top: @image-ratio;
		width: 100%;
		overflow: hidden;

		.image-content-shadow {
			position: absolute;
			left: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
		}
	}

	.image {
		position: relative;
		z-index: 3;
		padding-top: @image-ratio;
		width: 100%;
		overflow: hidden;

		.image-content {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transition: transform 0.3s ease;
		}

		.image-placeholder {
			width: 100%;
			height: 100%;
			background-color: rgba(@light-color-rgb, 0.1);
		}

		.image-error {
			width: 100%;
			height: 100%;
			background-color: rgba(@light-color-rgb, 0.1);
			position: relative;

			.error-icon {
				position: absolute;
				top: 32%;
				left: 0;
				right: 0;
				margin: auto;
				text-align: center;
				font-size: 32px;
				color: rgba(@light-color-rgb, 0.3) !important;
			}
		}
	}

	.content {
		position: absolute !important;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 3;
		padding: 16px 12px 12px;
		background: linear-gradient(180deg, rgba(@dark-color-rgb, 0) 0%, rgba(@dark-color-rgb, 0.8) 100%);
		backdrop-filter: blur(50px);
		.thinner-border(1px solid rgba(@light-color-rgb, 0.3), none, none, none);

		.value {
			height: 48px;
			color: @light-color;
			font-size: 16px;
			font-weight: 500;
			line-height: 24px;
		}

		.value-section {
			margin-top: 8px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.sub-value {
				color: rgba(@light-color-rgb, 0.7);
				font-size: 14px;
				font-weight: 400;
				line-height: 18px;
			}

			.date {
				color: rgba(@light-color-rgb, 0.7);
				font-size: 14px;
				font-weight: 400;
				line-height: 18px;
			}
		}
	}
}

.rs-d-surf-container {
	.surf-inline-three-image-text {
		padding-bottom: 70px;
	}
	.image {
		padding-top: 56.03%;
	}
}

.mob-surf-layout {
	.surf-inline-three-image-text-wrapper {
		&::after {
			border-color: var(--surf-secondary-color);
		}
	}

	.surf-inline-three-image-text {
		.image {
			padding-top: 55.76%;
		}
		.content {
			padding: 8px;

			.value {
				font-size: 12px;
				font-weight: 500;
				line-height: 16px;
				height: 32px;
			}
			.value-section {
				margin-top: 4px;

				.date,
				.sub-value {
					font-size: 8px;
					line-height: 12px;
				}
			}
		}
	}
}
</style>
